var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-2",on:{"click":_vm.clicked}},[_c('v-img',{staticClass:"white--text align-end",attrs:{"height":"200px","src":'data:image/png;base64, ' + _vm.trip.PhotoData}},[_c('v-card-title',[_vm._v(_vm._s(_vm.trip.Name))]),_c('v-card-text',[_vm._v(_vm._s(_vm.trip.CarUsed))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }